// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"152":"1ee3f81c","374":"9dce85a1","630":"aafddca0","674":"e5c4dd38"}[chunkId] + ".css";
};